import { render, staticRenderFns } from "./Cognition.vue?vue&type=template&id=50d435dc&scoped=true"
import script from "./Cognition.vue?vue&type=script&lang=js"
export * from "./Cognition.vue?vue&type=script&lang=js"
import style0 from "./Cognition.vue?vue&type=style&index=0&id=50d435dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d435dc",
  null
  
)

export default component.exports